import React from 'react';
import _classNames from 'classnames';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { makeSelectClientDetails } from 'containers/Main/selectors';
import useSiteCopySelector from 'components/useSiteCopySelector';
import useSiteConfigSelector from 'components/useSiteConfigSelector';

const useStyles = makeStyles({
  root: {
    '& input': {
      height: '1.2em',
    },
    '& select': {
      height: '1.2em',
      lineHeight: '1.35',
    },
  },
  padded: {
    '& input': {
      padding: '16px 14px',
    },
    '& select': {
      padding: '16px 14px',
    },
  },
  fontSize: {
    fontSize: '1.063rem',
  },
  disabledColor: {
    color: '#999999',
  },
  helperText: {
    fontWeight: '400',
    fontSize: '0.75rem',
  },
});

function DemographicsSelect({ plain, type, value, onChange, error, required }) {
  const classes = useStyles();
  const clientDetails = useSelector(makeSelectClientDetails());
  const [siteCopy] = useSiteCopySelector(['sign-up']);
  const [siteConfig] = useSiteConfigSelector(['Age and Gender Mappings']);
  const defaultConfig = _get(siteConfig, ['config', type, 'default'], []);
  const clientCustomDemographics = _get(
    clientDetails,
    'context.customDemographics',
    {},
  );
  const clientCustomConfig = _get(
    clientCustomDemographics,
    [type, 'options'],
    [],
  );
  const optionsConfig = !_isEmpty(clientCustomConfig)
    ? clientCustomConfig
    : defaultConfig;
  const options = (
    <>
      <option value="-1" disabled>
        {_get(siteCopy, [
          'pageCopy',
          `${type}Options`,
          _get(siteConfig, ['config', type, 'placeholder']),
        ])}
      </option>
      {optionsConfig.map(option => (
        <option value={option.value} key={option.label}>
          {_get(
            siteCopy,
            ['pageCopy', `${type}Options`, option.label],
            option.label,
          )}
        </option>
      ))}
    </>
  );

  return (
    <TextField
      id={type}
      name={type}
      label={_get(siteCopy, ['pageCopy', `${type}Placeholder`])}
      onChange={onChange}
      classes={{
        root: _classNames(classes.root, {
          [classes.padded]: !plain,
        }),
      }}
      value={value}
      fullWidth
      select
      required={required}
      error={error}
      helperText={
        error ? _get(siteCopy, ['pageCopy', `${type}Error`]) : undefined
      }
      FormHelperTextProps={{
        classes: {
          root: classes.helperText,
        },
      }}
      SelectProps={{
        native: true,
        classes: {
          root: _classNames({
            [classes.disabledColor]: value === '-1',
          }),
        },
      }}
      InputProps={{
        classes: {
          root: classes.fontSize,
        },
      }}
      InputLabelProps={{
        classes: {
          root: classes.fontSize,
        },
      }}
      variant={plain ? 'standard' : 'outlined'}
    >
      {options}
    </TextField>
  );
}

DemographicsSelect.propTypes = {
  error: PropTypes.bool,
  plain: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default DemographicsSelect;
